module.exports = __webpack_public_path__ + "static/home-banner-small-11a4b0fcebbfcea6aa5334c57879cf5c.jpg";